import { Dialog, DialogContent, Box, DialogTitle } from "@mui/material";

export default function SharedModal({
  isOpen,
  setIsOpen = () => null,
  modalHeader,
  modalBody,
}) {
  return (
    <Dialog
      open={isOpen}
      onClose={() => setIsOpen(false)}
      closeOnEsc
      scrollBehavior={"inside"}
    >
      <DialogTitle>{modalHeader}</DialogTitle>
      <DialogContent>{modalBody}</DialogContent>
    </Dialog>
  );
}
